export default "__VITE_ASSET__53d26e93__$_?component__"